import common from "./common";
import tools from "./tools";

export default {
  ...common,
  ...tools
};



// WEBPACK FOOTER //
// ./src/utils/index.js